import { toast } from '../../../shared/ui/toastStore'

/**
 * Сообщения о заказе после действий со сделкой (12.10.2026): отметка «Счёт» сама
 * оформляет заказ, снятие отметки убирает позиции из него.
 */
export function toastOrderAfterDeal(res: {
  orderId?: string | null
  orderCreated?: boolean
  orderWarning?: string | null
}) {
  if (res.orderWarning) {
    toast.error(res.orderWarning)
    return
  }
  if (!res.orderId) return
  toast.success(
    res.orderCreated
      ? 'Заказ оформлен — он в разделе «Заказы». Условия оплаты можно поменять в заказе'
      : 'Позиции добавлены в заказ отдельным счётом',
  )
}

export function toastOrderAfterClear(res: {
  orderDeleted?: boolean
  orderWarning?: string | null
}) {
  if (res.orderWarning) toast.error(res.orderWarning)
  else if (res.orderDeleted) toast.info('В заказе не осталось позиций — заказ удалён')
}
